window.StandardCartCalc = (function () {
    var expressCommonCoef = 0;

    var calc = function (type, betSum, items, currency, isBonusExpress) {
        var result = {
            betSum: 0,
            coef: 0,
            PossibleMoneyValue: 0,
            bonusExpressAmountValue: 0
        };
        var selectedItemsCnt = 0;

        for (key in items) {
            if (items[key].isSelected)
                ++selectedItemsCnt;
        }

        if (selectedItemsCnt === 0)
            return result;

        switch (type.toLowerCase()) {
            case 'single':
                result = calcSingle(items);
                break;
            case 'express':
                result = calcExpress(betSum, items, currency, isBonusExpress);
                break;
            case 'system':
                result = calcSystem(betSum, items, currency);
                break;
            default:
                break;
        }

        if (!result.hasOwnProperty('betSum')) {
            result.betSum = betSum;
        }

        var betCurrencySum = currency === 'Bonuses' ? result.betSum / globalAppSettings.bonusExchangeRate : result.betSum;

        if (result.PossibleMoneyValue - betCurrencySum > globalAppSettings.maxWinSum) {
            result.PossibleMoneyValue = globalAppSettings.maxWinSum + betCurrencySum;
        }

        return result;
    };

    var calcSingle = function (items) {
        var PossibleMoneyValue = 0,
            betSum = 0,
            betSumBonus = 0,
            itemBetSum;

        for (key in items) {
            if (items[key].isSelected === true) {
                itemBetSum = parseInt(items[key].bet || 0);

                if (items[key].currency === BettingCart.currencyMap.BONUS) {
                    betSumBonus += itemBetSum;
                    itemBetSum = itemBetSum / globalAppSettings.bonusExchangeRate;
                }

                PossibleMoneyValue += itemBetSum * items[key].coefValue;
                betSum = itemBetSum + betSum;
            }
        }

        return {
            betSum: roundCalcResult(betSum),
            betSumBonus: betSumBonus,
            PossibleMoneyValue: roundCalcResult(PossibleMoneyValue),
        };
    };

    var calcExpress = function (betSum, items, currency, isBonusExpress) {
        var totalCoef = 1;

        isBonusExpress = isBonusExpress === true ? true : false;

        for (key in items) {
            if (items[key].isSelected === true) {
                totalCoef *= items[key].coefValue;
            }
        }

        if (currency === 'Bonuses') {
            betSum = betSum / globalAppSettings.bonusExchangeRate;
        } else if (isBonusExpress) {
            totalCoef = totalCoef * 1.05;
        }
        expressCommonCoef = roundCalcResult(totalCoef, 2, 'bank');

        return {
            coef: expressCommonCoef,
            PossibleMoneyValue: roundCalcResult(betSum * expressCommonCoef, 2),
            bonusExpressAmountValue: betSum * 18
        };
    };

    var calcSystem = function (betSum, items, currency) {
        var coefVals = [];
        var selectContainer = $('[js-node="standard-cart__not-win-events-count"]');
        var notWinEventCount = selectContainer.find('option:selected').length > 0 ? Number(selectContainer.find('option:selected').val()) : 1;
        selectContainer.html('');

        if (Object.keys(items).length > 16) {
            return {
                'RangeList': [],
                'NotWinEventCount': 0,
                'OptionCount': 0,
                'TotalMoneyVal': 0,
                'PossibleMoneyValue': 0
            }
        }

        for (key in items) {
            if (items[key].isSelected === true) {
                coefVals.push(items[key].coefValue);
            }
        }

        if (currency === 'Bonuses')
            betSum = betSum / globalAppSettings.bonusExchangeRate;

        var result = calcSystemObj.init(coefVals, betSum, notWinEventCount);

        for (var i = 0; i < result.RangeList.length; i++) {
            selectContainer.append($("<option></option>")
                .attr("value", result.RangeList[i])
                .text(result.RangeList[i]));
        }

        result.PossibleMoneyValue = roundCalcResult(result.PossibleMoneyValue, 2);

        selectContainer.val(notWinEventCount);

        return result;
    };

    var roundCalcResult = function (value, precision = 2, type = 'math') {
        const powd = Math.pow(10, precision);
        if (type === 'bank') {
            const x = value * powd;
            const r = Math.round(x);
            const br = Math.abs(x) % 1 === 0.5 ? (r % 2 === 0 ? r : r - 1) : r;
            return br / powd;
        }
        return Math.round(value * powd) / powd;
    };

    return {
        calc: calc,
        getExpressCommonCoef: function () { return expressCommonCoef; }
    };
}());

window.calcSystemObj = (function () {
    function fact(n) {
        return n ? n * fact(n - 1) : 1;
    }

    function comb(n, lst) {
        if (!n) return [[]];
        if (!lst.length) return [];

        var x = lst[0],
            xs = lst.slice(1);

        return comb(n - 1, xs).map(function (t) {
            return [x].concat(t);
        }).concat(comb(n, xs));
    }

    function range(m, n) {
        return Array.apply(null, Array(n - m + 1)).map(function (x, i) {
            return m + i;
        });
    }

    function roundCalcResult(value, precision = 2, type = 'math') {
        const powd = Math.pow(10, precision);
        if (type === 'bank') {
            const x = value * powd;
            const r = Math.round(x);
            const br = Math.abs(x) % 1 === 0.5 ? (r % 2 === 0 ? r : r - 1) : r;
            return br / powd;
        }
        return Math.round(value * powd) / powd;
    }

    var init = function (coefVals, bet, notWinEventCount) {
        var count = coefVals.length;

        //RangeList (то, что должно быть в выпадающем списке)
        var rangeList = [];
        for (var i = 1; i < count - 1; i++) {
            rangeList.push(i);
        }
        // storage[] - это доступ к полям корзины, которые сохранены в памяти на момент изменения и перерасчета корзины.
        //Получение сохраненного notWinEventCount и проверка на то, что он принадлежит обновленному RangeList
        //notWinEventCount = storage[notWinEventCount]
        //if (rangeList.IndexOf(NotWinEventCount) == -1){
        //  notWinEventCount = rangeList.first();
        //}

        //а пока просто присвоим единице
        if (!notWinEventCount || notWinEventCount > count) notWinEventCount = 1;

        //получаем кол-во вариантов для нашего notWinEventCount
        var optCount = fact(count) / (fact(notWinEventCount) * fact(count - notWinEventCount));

        //Get ComoArray[[]]
        var combo = comb(count - notWinEventCount, range(0, count - 1));

        var coefsSum = 0;

        for (keyH in combo) {
            var miniExpressCoef = 1;
            for (keyL in combo[keyH]) {
                miniExpressCoef *= coefVals[combo[keyH][keyL]];
            }
            coefsSum += miniExpressCoef;
        }

        var expSum = roundCalcResult(coefsSum / optCount, 2, 'bank');

        var totalWin = roundCalcResult(expSum * bet);

        return {
            'RangeList': rangeList,
            'NotWinEventCount': notWinEventCount,
            'OptionCount': optCount,
            'TotalMoneyVal': bet,
            'PossibleMoneyValue': totalWin
        }
    }

    return {
        'init': init
    }
}());